import * as React from 'react';

export const Show = (props: { condition: any; children: any }): JSX.Element => {
  const { condition, children } = props;
  return <>{condition ? children : <></>}</>;
};
